// extracted by mini-css-extract-plugin
export var filterIncDec = "_54-0";
export var leftBorder = "_54-1";
export var rightBorder = "_54-2";
export var stringInput = "_54-3";